export default {
  computed: {
    subGroupEffectiveDate () {
      const effectiveDate = this.computedCurrentSubGroupPlanInfo.effectiveDate || this.computedCurrentSubGroupPlanInfo.subGroupEffectiveDate
      if (effectiveDate) {
        return effectiveDate
      }

      return null
    },
    subGroupTermDate () {
      const termDate = this.computedCurrentSubGroupPlanInfo.termDate || this.computedCurrentSubGroupPlanInfo.terminationDate || this.computedCurrentSubGroupPlanInfo.subGroupTerminationDate
      if (termDate) {
        return termDate
      }

      return null
    },
    groupEffectiveDate () {
      if (this.computedCurrentSubGroupPlanInfo.groupEffectiveDate) {
        return this.computedCurrentSubGroupPlanInfo.groupEffectiveDate
      }

      return null
    },
    groupTermDate () {
      if (this.computedCurrentSubGroupPlanInfo.groupTerminationDate) {
        return this.computedCurrentSubGroupPlanInfo.groupTerminationDate
      }

      return null
    },
    currentClass() {
      return this.getFirstClassByClassId(this.classId)
    },
    classEffectiveDate () {
      if (this.currentClass) {
        return this.currentClass.classEffectiveDate
      }

      return null
    },
    classTermDate () {
      if (this.currentClass) {
        return this.currentClass.classTerminationDate
      }

      return null
    },
    currentPlan () {
      return this.getFirstPlanByClassAndPlanId(this.classId, this.planId)
    },
    planEffectiveDate () {
      if (this.currentPlan) {
        return this.currentPlan.planEffectiveDate
      }

      return null
    },
    planTermDate () {
      if (this.currentPlan) {
        return this.currentPlan.planTerminationDate
      }

      return null
    }
  }
}
